import {getLayerByName} from "@/helpers/ol/ol-layer-helper";

export function getFeatureByFeatureID(layerName, featureID, primaryKeyName) {
    const layer = getLayerByName(layerName)

    let feature = null

    if(layer) {

        if(primaryKeyName) {
            layer.getSource().getFeatures().forEach((sourceFeature) => {
                if(String(sourceFeature.get(primaryKeyName)) === String(featureID)) {
                    feature = sourceFeature
                }

                if(featureID.includes('.')) {
                    if(String(sourceFeature.get(primaryKeyName)) === String(featureID.split('.')[1])) {
                        feature = sourceFeature
                    }
                }
            })
        } else {
            feature = layer.getSource().getFeatureById(featureID)
        }
    }

    return feature
}
